import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CheckButtonComponent } from '@app/shared/check-button/check-button.component';

@NgModule({
  declarations: [CheckButtonComponent],
  imports: [CommonModule, MatProgressBarModule],
  exports: [CheckButtonComponent],
})
export class CheckButtonModule {}
